/**
 * Task due_date + due_time helpers (mirrors backend taskDueDateTime.js).
 * Default due_time is end of day (23:59).
 */

export const DEFAULT_DUE_TIME = '23:59:00';
export const DEFAULT_DUE_TIME_INPUT = '23:59';

export function normalizeDueTime(dueTime) {
  if (dueTime == null || String(dueTime).trim() === '') {
    return DEFAULT_DUE_TIME;
  }

  let s = String(dueTime).trim();
  if (s.includes('T') || (s.includes(' ') && s.includes(':'))) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) {
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
    }
  }
  if (s.includes('.')) s = s.split('.')[0];

  const parts = s.split(':').map(p => parseInt(p, 10));
  if (parts.some(n => Number.isNaN(n))) return DEFAULT_DUE_TIME;

  const hours = Math.max(0, Math.min(23, parts[0] || 0));
  const minutes = Math.max(0, Math.min(59, parts[1] || 0));
  const seconds = Math.max(0, Math.min(59, parts[2] || 0));
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function extractDateOnly(dueDate) {
  if (!dueDate) return null;
  if (dueDate instanceof Date) {
    if (Number.isNaN(dueDate.getTime())) return null;
    const y = dueDate.getFullYear();
    const m = String(dueDate.getMonth() + 1).padStart(2, '0');
    const d = String(dueDate.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  const match = String(dueDate).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
}

/** Combine due_date + due_time into a Date (local). Empty due_time → 23:59:00. */
export function combineDueDateAndTime(dueDate, dueTime) {
  const dateOnly = extractDateOnly(dueDate);
  if (!dateOnly) return null;
  const time = normalizeDueTime(dueTime);
  const [year, month, day] = dateOnly.split('-').map(Number);
  const [hours, minutes, seconds] = time.split(':').map(Number);
  const combined = new Date(year, month - 1, day, hours, minutes, seconds || 0, 0);
  return Number.isNaN(combined.getTime()) ? null : combined;
}

export function applyDefaultDueTimeIfNeeded(data) {
  if (!data || typeof data !== 'object') return false;
  const hasDueDate =
    data.due_date != null && String(data.due_date).trim() !== '';
  const hasDueTime =
    data.due_time != null && String(data.due_time).trim() !== '';
  if (hasDueDate && !hasDueTime) {
    data.due_time = DEFAULT_DUE_TIME;
    return true;
  }
  return false;
}
